import BagsImg1 from "../assets/BagsImg1.jpg"
import BagsImg2 from "../assets/BagsImg2.jpg"
import BagsImg3 from "../assets/BagsImg3.jpg"
import BagsImg4 from "../assets/BagsImg4.jpg"
import BagsImg5 from "../assets/BagsImg5.jpg"
import BagsImg6 from "../assets/BagsImg6.jpg"
import BagsImg7 from "../assets/BagsImg7.jpg"
import BagsImg8 from "../assets/BagsImg8.jpg"
import BagsImg9 from "../assets/BagsImg9.jpg"
import BagsImg10 from "../assets/BagsImg10.jpg"
export const Baglist =[
{
    id: "b1",
    name: "Harry potter", 
    Price: 1200,
    imgsrc:BagsImg1,
},
{
    id: "b2",
    name: "Animoda Bag", 
    Price: 680,
    imgsrc:BagsImg2,
},
{
    id: "b3",
    name: "AniCute Bag", 
    Price: 760,
    imgsrc:BagsImg3,
},
{
    id: "b4",
    name: "Kakashi Bag", 
    Price: 900,
    imgsrc:BagsImg4,
},
{
    id: "b5",
    name: "Jujutsu Kaisen", 
    Price: 1001,
    imgsrc:BagsImg5,
},
{
    id: "b6",
    name: "Cosmus Bag", 
    Price: 1350,
    imgsrc:BagsImg6,
},
{
    id: "b7",
    name: "FLYMEI Bag", 
    Price: 885,
    imgsrc:BagsImg7,
},
{
    id: "b8",
    name: "Goku Bag", 
    Price: 578,
    imgsrc:BagsImg8,
},
{
    id: "b9",
    name: "Kawaii Bags", 
    Price: 1400,
    imgsrc:BagsImg9,
},
{
    id: "b10",
    name: "Cosmetic Bag", 
    Price: 950,
    imgsrc:BagsImg10,
},
];